import {mapGetters} from "vuex";
import TicketMessage from "../../components/TicketMessage/TicketMessage.vue";
import SupportUploadFile from "../../components/SupportUploadFile/SupportUploadFile.vue";
import Preloader from "../../components/Preloader/Preloader.vue";
import InfoMessage from "../../components/AlertMessage/InfoMessage.vue";
import UploadFilesMultipart from "../../components/UploadFilesMultipart/UploadFilesMultipart.vue";
import axios from 'axios';
import ImagePreviewModal from "@/components/__new_ui_kit/Modals/ImagePreviewModal/ImagePreviewModal";
import {defaultModalEvents, defaultModalProps} from "@/components/__new_ui_kit/Modal/defaults";
import BButton from "@/components/__new_ui_kit/Button/BButton";
export default {
    name: 'SupportDialog',
    data() {
        return {
            preloading: true,
            message: '',
            image: null,
            showImageLightBox: false,
            showingImage: '',
            file_arr: [],
            namesFiles:[],
            sizeError: false,
            sizeEnable: 5,
            limitNumberFiles: 10,
            errors: {},
            isDisabledBtn: false,
            messageError: false,
            longTextError: false
        }
    },
    components: {
        TicketMessage, SupportUploadFile, Preloader, InfoMessage, UploadFilesMultipart, BButton
    },
    computed: {
        ...mapGetters(['getTicketMessages','getTicketStatus', 'isLoggedIn']),
        sendImageArr() {
            return this.file_arr
        }
    },
    methods: {
        paste(event) {
            let clipboardData = event.clipboardData || window.clipboardData;
            let pastedText = clipboardData.getData('text');
            if (pastedText.length > 1000) {
                this.longTextError = true
            }
        },
        getFiles(data) {
            this.file_arr = data;
        },
        getChild(name) {
            for (let child of this.$children) if (child.$options._componentTag == name) return child;
        },
        send_message() {
            this.isDisabledBtn = true;
            this.$store.dispatch('create_ticket_message', {ticket_id: this.$route.params.id, body: this.message, files: this.sendImageArr})
                .then(()=> {
                    let uploader = this.getChild('UploadFilesMultipart');
                    uploader.deleteAllFiles();
                    this.$store.dispatch('get_ticket_messages', {ticket_id: this.$route.params.id}).then()
                    this.message = ''
                    this.file_arr = []
                    this.namesFiles = []
                    document.querySelector('#files').value = ""
                    this.isDisabledBtn = false;
                    this.errors = {}
                }).catch(error => {
                    console.log(error);
                    if (this.message.length === 0) {
                        this.messageError = true;
                    }
                    this.isDisabledBtn = false;
                    this.errors = error.response.data.error;
            });
        },
        previewImage(imageSrc) {
            this.$modal.show(ImagePreviewModal, {imageSrc},
              {...defaultModalProps('image-preview-modal'), name: "image-preview-modal"},
              {...defaultModalEvents()}
            )
        },
        leaveTextarea() {
            if (this.message.length === 0) {
                this.messageError = true
            }
        },
    },
    watch: {
        message (val) {
            this.errors = {}
            if (val.length < 1000) {
                this.longTextError = false
            }
        }
    },
    mounted() {
        this.$store.dispatch('reset_counter_messages_for_ticket', {ticket_id: this.$route.params.id})
            .catch(() => {})
    },
    created() {
        this.$store.dispatch('get_ticket_messages', {ticket_id: this.$route.params.id})
            .then((response) => {
                this.preloading = false
            })
            .catch(error => {
                this.$router.push('/not-found')
            })
    }
}
